<template>
  <section class="card">
    <header class="header-card">
      <p> {{ $t('editionFormatAffiche.informationGeneral') }} </p>
    </header>
    <div class="card-content">
      <div class="columns is-multiline">
        <b-field
          :label="$t('editionFormatAffiche.fields.code')"
          :class="{ 'obligatoire': !detail }"
          class="column is-3">
          <b-input v-if="!detail" v-model="formatAffiche.code"></b-input>
          <span v-else>{{ formatAffiche.code }}</span>
        </b-field>
        <b-field
          :label="$t('editionFormatAffiche.fields.libelle')"
          :class="{ 'obligatoire': !detail }"
          class="column is-3">
          <b-input v-if="!detail" v-model="formatAffiche.libelle"></b-input>
          <span v-else>{{ formatAffiche.libelle }}</span>
        </b-field>
        <parametre-autocomplete
          v-if="!detail"
          v-model="formatAffiche.natureSupportAfficheId"
          :label="$t('editionFormatAffiche.fields.natureSupportAffiche')"
          :target="constantes.PARAMETRES_KEYS.natureSupportAffiche"
          class="column is-3"
          required
        />
        <b-field
          v-else
          :label="$t('editionFormatAffiche.fields.natureSupportAffiche')"
          class="column is-3">
          {{ formatAffiche.natureSupportAffiche.libelle }}
        </b-field>
        <parametre-autocomplete
          v-if="!detail"
          v-model="formatAffiche.typeMaterielId"
          :label="$t('editionFormatAffiche.fields.typeMateriel')"
          :target="constantes.PARAMETRES_KEYS.materielType"
          class="column is-3"
          required
        />
        <b-field
          v-else
          :label="$t('editionFormatAffiche.fields.typeMateriel')"
          class="column is-3">
          {{ formatAffiche.typeMateriel.libelle }}
        </b-field>
        <b-field
          :label="$t('editionFormatAffiche.fields.largeur')"
          class="column is-3">
          <b-input
            v-if="!detail"
            v-model.number="formatAffiche.largeur"
            :use-html5-validation="false"
            type="number"
            step="0.01"
          />
          <span v-else>{{ formatAffiche.largeur }}</span>
        </b-field>
        <b-field
          :label="$t('editionFormatAffiche.fields.longueur')"
          class="column is-3">
          <b-input
            v-if="!detail"
            v-model.number="formatAffiche.longueur"
            :use-html5-validation="false"
            type="number"
            step="0.01"
          />
          <span v-else>{{ formatAffiche.longueur }}</span>
        </b-field>
      </div>
    </div>
  </section>
</template>

<script>
import ParametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';

export default {
  name: 'InformationGeneralEdit',
  props: {
    formatAffiche: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ParametreAutocomplete,
  },
  data() {
    return {
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
};
</script>
